<div class="modal-list-dialog-wrapper">
    <div class="dialog-header">
        <div class="header-left">
            <label class="title-label">{{dialogTitle}}</label>
            <div class="header-search scope-list-search">
                <mat-form-field class="search-input">
                    <input matInput [placeholder]="dynamicPlaceholder" [(ngModel)]="searchText"
                        (keyup)="applyFilter(searchTextField?.value)" autofocus="false" #searchTextField
                        autocomplete="off" />
                    <i class="fas fa-search" matPrefix aria-hidden="true"></i>
                    <i *ngIf="searchText" (click)="clearSearch()" class="fa fa-times clear-search-icon" matSuffix
                        aria-hidden="true"></i>
                </mat-form-field>
            </div>
        </div>

        <div class="header-right">
            <div class="close-icon-wrapper">
                <i class="fa fa-times close-icon" (click)="closeDialog()" aria-hidden="true"></i>
            </div>
        </div>
    </div>

    <div class="table-container d-flex flex-column p-t-0" *ngIf="!isLoading">
        <table cdk-table [dataSource]="[]" class="other-roles-tbl" matSort
            (matSortChange)="onSortChange($event)">

            <ng-container cdkColumnDef="Manufacturer">
                <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="manufacturerName" class="col-max-width">
                    Manufacturer Name
                </th>
            </ng-container>

            <ng-container cdkColumnDef="Model">
                <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="label" class="col-max-width">
                    Model Name
                </th>
            </ng-container>

            <ng-container cdkColumnDef="Description">
                <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="description">
                    Description
                </th>
            </ng-container>

            <ng-container cdkColumnDef="Point Name">
                <th cdk-header-cell *cdkHeaderCellDef mat-sort-header="label">
                    Point Name
                </th>
            </ng-container>

            <!-- Sticky Header -->
            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></tr>
        </table>

        <!-- Virtual Scroll Viewport -->
        <cdk-virtual-scroll-viewport itemSize="26" class="virtual-scroll-viewport"
        [style.height.px]="getViewportHeight()"
        [style.maxHeight.px]="380">
            <table class="other-roles-tbl">
                <tr class="table-row" *cdkVirtualFor="let row of dataSource; trackBy: trackByFn" (click)="selectRow(row)"
                    [ngClass]="{
                        'selected-row': data.isPointModal ? row.value === selectedRowId : 
                        row.value === selectedRowId && row.version === data.selectedData?.version }"
                    >
                    <ng-container *ngIf="!data.isPointModal">
                        <td class="col-max-width"
                            [matTooltipClass]="'domain-dialog-tooltip'" matTooltip="" matTooltipPosition="above"
                            showTooltipOnOverflow>
                            {{ row.manufacturerName }}
                        </td>

                
                        <td class="col-max-width">
                            <div class="label-version-container">
                                <span class="label truncate" matTooltip="" [matTooltipClass]="'domain-dialog-tooltip'" matTooltipPosition="above"
                                    showTooltipOnOverflow>{{ row.label }}</span>
                                <span class="version" *ngIf="row.versionLabel">{{row.versionLabel}}</span>
                            </div>
                        </td>

                        <td class="p-l-5 p-r-10 description"
                            matTooltip="" [matTooltipClass]="['domain-dialog-tooltip', 'domain-dialog-tooltip-description']"
                            matTooltipPosition="above" showTooltipOnOverflow>
                            {{ row.description ? row.description : '-' }}
                        </td>
                    </ng-container>


                    <td *ngIf="data.isPointModal" class="p-l-5 p-r-10"
                        matTooltip="" [matTooltipClass]="['domain-dialog-tooltip']"
                        matTooltipPosition="above" showTooltipOnOverflow>
                        {{ row.label ? row.label : '-' }}
                    </td>

            </table>
        </cdk-virtual-scroll-viewport>

        <div class="noModals" *ngIf="dataSource.length === 0">No model found.</div>
    </div>

    <ng-container *ngIf="isLoading">
        <div class="data-loader-container">
            <ngx-skeleton-loader
                [theme]="{ 'border-radius': '0', 'height': '25px', 'background-color': '#eff0f1'}" count="2">
            </ngx-skeleton-loader>
        </div>
    </ng-container>
</div>